<template>
  <captcha-container
    v-slot="{ generateCaptchaToken, isLoading: captchaIsLoading }"
    action="printable_reward_link_redemption"
  >
    <form
      class="printable-reward-link-redemption-form"
      novalidate
      @submit.prevent
    >
      <v-text-field
        id="printable-redeem-code"
        v-validate="{
          required: true,
          min: 16,
          regex: onlyCountAlphanumericCharactersRegex
        }"
        v-mask="'XXXX-XXXX-XXXX-XXXX'"
        :value="code"
        :label="$t('printable.form.codeInputLabel')"
        name="printable-redeem-code"
        :placeholder="$t('printable.form.codeInputPlaceholder')"
        data-vv-as="code"
        background-color="white"
        outlined
        :error-messages="formErrorMessage"
        @input="updateCode"
      />
      <tc-v-btn
        id="printable-redeem-button"
        class="printable-redeem-button"
        type="submit"
        color="primary"
        :disabled="buttonIsDisabled(captchaIsLoading)"
        :loading="buttonIsDisabled(captchaIsLoading)"
        :loading-text="$t('printable.form.buttonText')"
        @click.prevent="onSubmit(generateCaptchaToken)"
      >
        {{ $t('printable.form.buttonText') }}
      </tc-v-btn>
      <p
        v-if="errorMessage"
        class="printable-reward-link-redemption-form__error_response_message"
      >
        {{ errorMessage }}
      </p>
    </form>
  </captcha-container>
</template>

<script>
import CaptchaContainer from '../shared/captcha/CaptchaContainer'

export default {
  name: 'PrintableRewardLinkRedemptionForm',
  components: { CaptchaContainer },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    code: ''
  }),
  computed: {
    formErrorMessage () {
      return this.errors.first('printable-redeem-code')
    },
    cleanedCode () {
      // Remove all non-word characters and underscores from the string
      return this.code.replace(/[\W_]+/g, '')
    },
    onlyCountAlphanumericCharactersRegex () {
      // Match exactly 16 alphanumeric characters with any number of non-word characters or
      // underscores before or between
      return /^[\W_]*([a-zA-Z0-9][\W_]*){16}$/
    }
  },
  methods: {
    async onSubmit (generateCaptchaToken) {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        const captchaToken = await generateCaptchaToken()
        this.$emit('submit', {
          code: this.cleanedCode,
          captchaToken
        })
      }
    },
    buttonIsDisabled (captchaIsLoading) {
      return this.isLoading || captchaIsLoading
    },
    updateCode (code) {
      const codeToConvert = code || ''
      this.code = codeToConvert.toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

#printable-redeem-code::placeholder {
  color: #adb5bd;
}

#printable-redeem-code:focus::placeholder {
  color: transparent;
}

#printable-redeem-button {
  width: 280px;
  margin: auto;
}

.printable-reward-link-redemption-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.printable-reward-link-redemption-form__loading-spinner {
  font-size: 18px;
}

.printable-reward-link-redemption-form__error_response_message {
  color: $tangoDangerRed;
  text-align: center;
  margin-top: 10px;
}
</style>
